module.exports = __webpack_public_path__ + "static/media/scenario.010726b0.svg";